<template>
  <div>
    <ul class='m-t-50 p-l-115'>
      <li class='m-b-40'>
        <label>触发项目：</label>
        <p>上架商品已售馨；上架商品缺货预警提示；待发货订单通知；退换货申请通知；拼团成功提醒发货；拼团失败提醒退款；积分换购已抢光通知；
          满额减送即将结束提示；满额包邮即将结束提示；限时打折即将结束提示；领券活动即将结束提示；购买即送结束提示；</p>
      </li>
      <li class='m-b-40'>
        <label>接收方式：</label>
        <div>
          <span>
            <input type="checkbox" name="email" :checked="form.email" v-model="form.email" id="email" hidden>
            <label for="email" class='sendWayRadio m-r-40'>站内信
            </label>
          </span>
          <span>
            <input type="checkbox" v-model="form.sms"  :checked="form.sms" name="sms" id="sms" hidden>
            <label for="sms" class='sendWayRadio'>手机短信
            </label>
          </span>
        </div>
      </li>
      <li class='m-b-40'>
        <label>接收人：</label>
        <a-transfer :data-source="data" :titles="['接收人管理', '已选']" :target-keys="targetKeys" :selected-keys="selectedKeys" :render="item => item.name" @change="onChange" @selectChange="handleSelectChange" @scroll="handleScroll" :list-style="{
      width: '300px',
      height: '300px',
    }">
        </a-transfer>
      </li>
      <li class='m-b-40'>
        <label></label>
        <div>
          <a-button type="primary" @click='submit'>
            提交
          </a-button>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import { getmessageDetail, getreceiver, setAllMessage } from "@/api/message";
import { inject, ref } from "vue";
import { iscode } from "../../../../utils/app";
export default {
  setup() {
    const _lodash = inject("_lodash");
    const route = inject("$route");
    const router = inject("$router");
    // 接收人
    const data = ref([]);
    const initData = async (values) => {
      let res = await getreceiver(values).then((res) => res);
      data.value = res.data.data;
      data.value = _lodash.map(data.value, function (element) {
        return _lodash.extend({}, element, { key: element.id });
      });
    };
    initData();
    const targetKeys = ref([]);
    const onChange = (nextTargetKeys) => {
      targetKeys.value = nextTargetKeys;
    };
    const form = ref({
      email: 1,
      sms: 1,
      wx:1
    });
    // 批量设置
    const submit = async () => {
      let data = {
        ...form.value,
        project_id: JSON.parse(route.query.selectedRowKeys).join(","),
        receivers: targetKeys.value.join(","),
      };
      let result = await setAllMessage(data)
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(result, true)) {
        router.go(-1);
      }
    };
    return {
      data,
      form,
      targetKeys,
      onChange,
      submit,
    };
  },
};
</script>
<style lang="less" scoped>
.tree-transfer .ant-transfer-list:first-child {
  width: 50%;
  flex: none;
}
li {
  max-width: 950px;
  display: flex;
  color: #333;
  label {
    width: 120px;
    color: #8e8e8e;
    font-size: 12px;
  }
  .sendWayRadio {
    width: 160px;
    text-align: center;
    height: 64px;
    border-radius: 5px;
    border: 1px solid #707c76;
    display: inline-block;
    line-height: 64px;
    font-size: 24px;
    position: relative;
    cursor: pointer;
    -moz-user-select: none; /*火狐*/
    -webkit-user-select: none; /*webkit浏览器*/
    -ms-user-select: none; /*IE10*/
    user-select: none;
  }
  input:checked ~ label::before {
    content: "";
    position: absolute;
    bottom: 0;
    right: 0;
    width: 0;
    height: 0;
    border-bottom: 40px solid #05486A;
    border-left: 40px solid transparent;
  }
  input:checked ~ label::after {
    content: "√";
    width: 20px;
    height: 20px;
    position: absolute;
    bottom: 25px;
    right: 5px;
    color: #fff;
    z-index: 10;
  }
}
</style>